import { createRouter, createWebHistory } from 'vue-router';

// Dynamically import components with chunk names
const Programs = () => import(/* webpackChunkName: "programs" */ './components/Programs.vue');
const Schools = () => import(/* webpackChunkName: "schools" */ './components/Schools.vue');
const Scholarships = () => import(/* webpackChunkName: "scholarships" */ './components/Scholarships.vue');
const ProgramSingle = () => import(/* webpackChunkName: "program-single" */ './components/ProgramSingle.vue');
const SchoolSingle = () => import(/* webpackChunkName: "school-single" */ './components/SchoolSingle.vue');
const ScholarshipSingle = () => import(/* webpackChunkName: "scholarship-single" */ './components/ScholarshipSingle.vue');
const MyDashboard = () => import(/* webpackChunkName: "my-dashboard" */ './components/MyDashboard.vue');
const Compare = () => import(/* webpackChunkName: "compare" */ './components/Compare.vue');
const HomeFilters = () => import(/* webpackChunkName: "home-filters" */ './components/HomeFilters.vue');

const routes = [
    { path: '/programs', component: Programs },
    { path: '/fr/programs', component: Programs },
    { path: '/schools', component: Schools },
    { path: '/fr/schools', component: Schools },
    { path: '/scholarships', component: Scholarships },
    { path: '/fr/scholarships', component: Scholarships },
    { path: '/program/:id', name: 'programSingle', component: ProgramSingle,  props: true },
    // { path: '/fr/program/:id', name: 'programSingleFr', component: ProgramSingle,  props: true },
    { path: '/school/:id', name: 'schoolSingle', component: SchoolSingle,  props: true },
    // { path: '/fr/school/:id', name: 'schoolSingleFr', component: SchoolSingle,  props: true },
    { path: '/scholarship/:id', name: 'scholarshipSingle', component: ScholarshipSingle },
    // { path: '/fr/scholarship/:id', name: 'scholarshipSingleFr', component: ScholarshipSingle },
    { path: '/my-dashboard', component: MyDashboard },
    { path: '/fr/my-dashboard', component: MyDashboard },
    { path: '/compare-programs', component: Compare },
    { path: '/fr/compare-programs', component: Compare },
    { path: '/compare-schools', component: Compare },
    { path: '/fr/compare-schools', component: Compare },
    { path: '/', component: HomeFilters },
    { path: '/fr/', component: HomeFilters },
];

const router = createRouter({
    history: createWebHistory('/'), // Ensure this matches your WordPress base URL
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return {
                ...savedPosition,
                behavior: 'smooth'
            }
        } else {
            return { 
                top: 0,
                left: 0,
                behavior: 'smooth'
            }
        }
    }
});

const PAGE_COUNT_KEY = 'page_visit_count';
const TRACKED_PATHS = [
    '/',
    '/fr/',
    '/programs',
    '/fr/programs',
    '/schools',
    '/fr/schools',
    '/scholarships',
    '/fr/scholarships',
    '/my-dashboard',
    '/fr/my-dashboard',
    '/compare-programs',
    '/fr/compare-programs',
    '/compare-schools',
    '/fr/compare-schools',
    '/school/',
    '/fr/school/',
    '/program/',
    '/fr/program/',
    '/scholarship/',
    '/fr/scholarship/'
];

// Add this navigation guard
router.beforeEach((to, from, next) => {
    if (to.name === 'programSingle' || 
        // to.name === 'programSingleFr' ||
        to.name === 'schoolSingle' ||
        // to.name === 'schoolSingleFr' ||
        // to.name === 'scholarshipSingleFr'
        to.name === 'scholarshipSingle' 
    ){
    // Check if the route is already resolved (e.g., not a page refresh)
        if (to.params.id) {
            next();
        } else {
            // Extract the ID from the URL path
            const pathParts = to.path.split('/');
            const id = pathParts[pathParts.length - 1];
            // Redirect to the same route with the extracted ID
            next({ name: to.name, params: { id } });
        }
    } else {
        next();
    }

    // Check if the path starts with any of our tracked paths
    const isTrackedPath = TRACKED_PATHS.some(path => 
        to.path.startsWith(path)
    );

    if (isTrackedPath) {
        let pageVisitCount = parseInt(localStorage.getItem(PAGE_COUNT_KEY)) || 0;
        pageVisitCount++;
        localStorage.setItem(PAGE_COUNT_KEY, pageVisitCount);
        console.log('Page visit count updated:', pageVisitCount);
    }
});

export default router;
